import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DefaultButton, FlexStack } from '~/components/atomic';
import { Input, PasswordInput } from '~/components/atomic';
import { PAGE_ROUTE } from '~/constants';
import AuthService from '~/services/AuthService';
import { useSignUpStepStore, useUserStore } from '~/store';
import useToast from '~/store/useToast';
import * as S from './SignInForm.styled';

export default function SignInForm() {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const { setStep, setType } = useSignUpStepStore((state) => ({
    setStep: state.setStep,
    setType: state.setType,
  }));
  const setUsers = useUserStore((state) => state.setUser);

  const resetUserData = useUserStore((state) => state.resetUserData);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleGoSignUp = () => {
    resetUserData();
    setStep('CheckEmail');
    setType('email');
    navigate(PAGE_ROUTE.SIGNUP);
  };

  const isFormInvalid = () => {
    return (
      isLoading || email.trim().length === 0 || password.trim().length === 0
    );
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (isFormInvalid()) {
      return;
    }

    setIsLoading(true);

    try {
      const {
        isSignedIn,
        nextStep: { signInStep },
      } = await AuthService.signInWithEmail(email, password);

      if (!isSignedIn) {
        if (signInStep === 'CONFIRM_SIGN_UP') {
          showToast(
            'error',
            'user is not verified. please complete your process.',
          );
          setUsers({ email, password });
          setStep('VerifyEmail');
          setType('email');
          navigate(PAGE_ROUTE.SIGNUP);
        } else {
          showToast('error', signInStep);
        }
      } else {
        const isVerified = await AuthService.verifySignIn();
        if (isVerified) {
          navigate(PAGE_ROUTE.MAIN);
        } else {
          showToast('error', 'User is not found.');
        }
      }
    } catch (error) {
      console.error(error);
      showToast('error', 'Please check your email or password.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <S.Container>
        <S.LoginWrapper>
          <FlexStack spacing={16}>
            <Input
              id='LoginEmail'
              placeholder='Email'
              text={email}
              setText={setEmail}
            />
            <PasswordInput
              placeholder='Password'
              text={password}
              setText={setPassword}
            />
          </FlexStack>
          <S.FindPasswordLink to={PAGE_ROUTE.RESET_PASSWORD}>
            <span>Forgot your password?</span>
          </S.FindPasswordLink>
        </S.LoginWrapper>

        <FlexStack spacing={16}>
          <DefaultButton
            type='submit'
            isLoading={isLoading}
            disabled={isFormInvalid()}
          >
            Sign in
          </DefaultButton>
          <S.SignUpLinkBox>
            <p>Don’t have an account?</p>
            <S.SignUpLink onClick={handleGoSignUp}>Sign up</S.SignUpLink>
          </S.SignUpLinkBox>
        </FlexStack>
      </S.Container>
    </form>
  );
}
